import { ListItemButton, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { isPathActive } from '../../Utilities/HelperMethods';
import { MobileMenuItemStyle } from './StyledComponents';

export const MobileNavButton = ({ to, label, location, toggleDrawer }) => {
  const isActive = isPathActive(location.pathname, to);

  return (
    <ListItemButton
      sx={{
        ...MobileMenuItemStyle,
        background: isActive ? '#0000000a !important' : '',
      }}
      component={NavLink}
      to={to}
      onClick={toggleDrawer}
    >
      <ListItemText primary={label} />
    </ListItemButton>
  );
};
